
import TagsInput from '@/components/Inputs/TagsInput'
import { Select, Option } from 'element-ui'
import HtmlEditor from '@/components/Inputs/HtmlEditor'
import moment from 'moment';
import HttpFactory from '@/mixins/http.factory';
export default {
	name:'create-issue',
	mixins:[HttpFactory],
	data () {
		return {
			htmlMessage:null,
			data:null,
			githubRepoData:{
				labelsList:['Web','Mobile','Pool','Farm','Vault','Save','Bridge','Tokens','NFT','Priority 0','Priority 1',
					'Priority 2','Ethereum','Polygon','BSC','Avalanche','Fantom','Arbitrum','Harmony','Celo','Optimism','Moonriver'],
                repoList:[],
                usersList:[],
				milestoneList:[]
            },
			showTags:false,
            editor_description_Obj:null,
            createIssueData:{attachments:[],files:[],issue:{}},
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			modalClient.on('send_data_to_modal', (data) => {
				if (data.ticket.id == _self.$route.params.zdTicketId) {
					parentClient = modalClient.instance(data.parentClientGuid)
					_self.zendeskInfo=data;
					_self.IssueFields();
				}
			});
		},
		initDropzone(data){
			const _self=this;
			if(!data || !data.userInfo || !data.userInfo.uploadFiles)return;
			_self.fn().initDropzone('div.dropzone',data.credentials,'github',function(error,response){
				if(error){
					return;
				}
				_self.createIssueData.files=_self.createIssueData.files.concat(response);
			});
		},
		removeFile(file){
			const _self=this;
			_self.createIssueData.files=_self.createIssueData.files.filter(d=>d.id!=file.id);
		},
		initcreateIssueData(data,repo){
			let _self=this;
			_self.createIssueData.issue={};
			
			let comments=_self.zendeskInfo.ticket.comments;
			if(comments){
				let description_html=comments && comments.length>0?comments[comments.length-1].value:_self.zendeskInfo.ticket.description;
				_self.createIssueData.issue['body']=description_html;
			}

			_self.createIssueData.hdTicketId=data.hdTicketId?data.hdTicketId:data.ticket.id;
			_self.createIssueData.issue['title']=data.ticket.subject;
			//console.log('zendesk info',data);
			_self.createIssueData.issue['assignees']='';
			_self.createIssueData.issue['labels']=[];
			_self.showTags=true;

			_self.createIssueData.issue['repo']=repo?repo.name:'';
			_self.createIssueData.issue['milestone']='';
			//_self.createIssueData.issue['repo']= repo?repo.name:'';
			//boolean

		},
		IssueFields(){
			let _self=this;
			_self.githubReposFn(function(repoResp){
				let repoList=repoResp.data.Data;
				_self.htmlMessage=repoResp.data.htmlMessage;
				if(repoList && repoList.length>0){
					_self.githubRepoData.repoList=repoList;
					_self.initcreateIssueData(_self.zendeskInfo,repoList[0]);
						_self.githubRepoDataList();
						_self.fn().showLoader(false);
						setTimeout(function(){_self.initDropzone(_self.zendeskInfo);},500);
						// setTimeout(function(){
						// 	let comments=_self.zendeskInfo.ticket.comments;
						// 	if(comments){
						// 		let description_html=comments && comments.length>0?comments[comments.length-1].value:_self.zendeskInfo.ticket.description;
						// 		_self.fn().createHtmlEditor('editor_description','editor_description',description_html,function(editorObj,error){
						// 			_self.editor_description_Obj=editorObj?editorObj:null;
						// 		});
						// 	}
						// },1000);
				}
				
			},function(err){
				_self.fn().showLoader(false);
				let erroList=[
					'We see your authentication token for the GitHub does not have required permissions.',
					'Can you please create GitHub token as per below article and update the app.',
					'https://support.devopsintegration.io/support/solutions/articles/82000555961-how-to-create-github-authentication-token-'
				]
				_self.userMsg={show:true,type:'danger',list:erroList};
			});
		},
		githubRepoDataList:async function(){
			const _self=this;
			//_self.createIssueData.issue.repo=_self.createIssueData.issue.repoObj?_self.createIssueData.issue.repoObj.name:null;
			let repo=_self.createIssueData.issue.repo;
			_self.githubRepoDataFn(repo,function(dataResp){
				_self.fn().showLoader(false);
				_self.githubRepoData.usersList= dataResp.data.Data.usersList;
				_self.githubRepoData.milestoneList= dataResp.data.Data.milestoneList;
			},function(err){
				_self.fn().showLoader(false);
				let erroList=[
					'We see your authentication token for the GitHub does not have required permissions.',
					'Can you please create GitHub token as per below article and update the app.',
					'https://support.devopsintegration.io/support/solutions/articles/82000555961-how-to-create-github-authentication-token-'
				]
				_self.userMsg={show:true,type:'danger',list:erroList};
			});
		},
		async validateForm(){
			let isValid=await this.$validator.validateAll();
			
			if(!isValid){
				this.userMsg={show:true,type:'danger',list:[`Please scroll up and fill all required fields.`]}
			}
			return isValid;
		},
		htmlEditorChange(data){
			const _self=this;
			//_self.createItemData.fields[data.referenceName]=data.htmlContent?data.htmlContent:null;
			_self.createIssueData.issue['body']=data.htmlContent?data.htmlContent:null;
		},
		//create init
		githubReposFn:function(successCb,errorCb){
            var _self=this;
            var url = `github/repos`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
		githubRepoDataFn:function(repo,successCb,errorCb){
            var _self=this;
            var url = `github/${repo}/data`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
        createIssueFn(){
			let _self=this;
			_self.fn().clearMessage();
		
			if(_self.editor_description_Obj)
				_self.createIssueData.issue['body']=_self.fn().getHtmlEditorContent(_self.editor_description_Obj);
			
			let data={..._self.createIssueData};
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			let url=`github/issues/create`;
			_self.postServerFn(url,data,function(response){
				_self.fn().showLoader(false);
				let userMsg;
				if(response.data.Success){
					userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Issue created Successfully`]}
					_self.sendDataToParent(response.data);
				}else{
					userMsg={show:true,type:'danger',list:[response.data.Data?response.data.Data:`Issue creation failed.`]}
				}
				_self.userMsg=userMsg;
			},function(error){ 
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		},
		postServerFn(url,data,successCb,errorCb){
			let _self=this;
			data=data?data:{};
			data.auth=_self.zendeskInfo.credentials;
			_self.post(url,data).then(response=>{
				if(successCb) successCb(response);
			}).catch(error=>{
				if(errorCb) errorCb(error);
			});
		}
	},
	components:{HtmlEditor,TagsInput,[Select.name]: Select,[Option.name]: Option}
}

